import {
  faCheckCircle,
  faExclamationCircle,
} from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';

import { Icon } from 'Icons';

const ICON_STYLES = 'align-baseline bg-white text-xl';

const Milestone = ({ disableNavButton, isActive, isComplete, isError }) => {
  if (isComplete) {
    return (
      <Icon
        className={`${ICON_STYLES} border-green-3 text-green-3 ${
          !disableNavButton && 'hover:border-green-4 hover:text-green-4'
        }`}
        icon={faCheckCircle}
      />
    );
  }

  if (isError) {
    return (
      <Icon
        className={`${ICON_STYLES} border-red-3 text-red-3`}
        icon={faExclamationCircle}
      />
    );
  }

  return (
    <span
      className={`inline-block border-4 border-solid rounded-full bg-white text-base h-6 w-6 p-0 ${
        isActive ? 'border-green-3' : 'border-gray-3'
      }`}
    />
  );
};

Milestone.propTypes = {
  disableNavButton: PropTypes.bool,
  isActive: PropTypes.bool,
  isComplete: PropTypes.bool,
  isError: PropTypes.bool,
};

Milestone.defaultProps = {
  disableNavButton: false,
  isActive: false,
  isComplete: false,
  isError: false,
};

export default Milestone;
